import type { ComponentProps, FC } from 'react';
import Markdown from 'react-markdown';
import { Typography } from './Typography';
import type { LinkProps } from './Typography/Link';

export interface RichProps extends ComponentProps<typeof Markdown> {
  linkPrint?: LinkProps['print'];
}

export const Rich: FC<RichProps> = ({ components, linkPrint, ...props }) => {
  return (
    <Markdown
      {...props}
      components={{
        a: ({ children, href }) => (
          <Typography.Link href={href} print={linkPrint}>
            {children}
          </Typography.Link>
        ),
        p: Typography.Paragraph,
        ...components,
      }}
    />
  );
};
